module.exports = __webpack_public_path__ + "img/2304.b935eb58.jpg";